<template>
  <v-row class="mb-0">
    <v-col cols="12" class="pt-0 pb-0">
      <v-row>
        <v-col class="pb-0 pr-0 pt-0 mt-0" cols="12" lg="12" md="12">
          <v-row class="comm-header-col data-query-section pb-0 pt-0 custom-figma-1">
            <v-col cols="12" lg="12" md="12" class="pt-0 pb-0 mb-0">
              <div class="d-flex align-center">
                <v-text-field
                  v-model="searchGroup"
                  :placeholder="$t('lbl.common.conditionSearch.findBySQLGroupName')"
                  hide-details
                  dense
                  filled
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn v-if="tab == 0" class="btn btn-top btn-add" @click="openAddSQLGroup(null)">
                  <span>
                    {{ $t('btn.common.add') }}
                  </span>
                </v-btn>
                <v-btn v-else class="btn btn-top btn-add" @click="openAddD2DSQLGroup(null)">
                  <span>
                    {{ $t('btn.common.add') }}
                  </span>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12" lg="12" md="12" class="pt-0 pb-0">
              <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle" />
              <v-data-table
                :search="searchGroup"
                :headers="SummaryList.headers"
                :hide-default-footer="true"
                :fixed-header="true"
                :items="items"
                :sort-desc="true"
                :height="tableHeight"
                :class="[
                  'list-table code-table srm-list-table custom-border-table',
                  items.length > 0 ? '' : 'custom-border-table-not-data',
                ]"
                item-key="rowid"
                pb-2
                disable-pagination
                sort-by="upd_dt"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr
                      v-for="(item, index) in items"
                      :key="item.rowid"
                      @click="onClickCodeGroup(item)"
                      @dblclick="onDblClickRowItem()"
                      :class="[
                        selectedRowGroup == item.sql_grp_id ||
                        (selectedRowGroup == '' && index == 0)
                          ? 'selected_row'
                          : '',
                      ]"
                    >
                      <td class="col-codegroup">{{ item.sql_grp_nm }}</td>
                      <td class="text-center">{{ item.upd_dt }}</td>
                      <td>{{ item.upd_user }}</td>
                      <td class="text-center">
                        <v-tooltip top :disabled="item.numofuse == 0">
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="btn-tooltip">
                              <v-btn
                                small
                                text
                                icon
                                :disabled="!$auth.manage || item.numofuse > 0"
                                @click="
                                  tab === 0 ? openAddSQLGroup(item) : openAddD2DSQLGroup(item)
                                "
                              >
                                <icon-svg
                                  :disabled="!$auth.manage || item.numofuse > 0"
                                  iconName="edit"
                                />
                              </v-btn>
                              <v-btn
                                small
                                text
                                icon
                                @click="deleteItem(item)"
                                :disabled="!$auth.manage || item.numofuse > 0"
                              >
                                <icon-svg
                                  :disabled="!$auth.manage || item.numofuse > 0"
                                  iconName="delete"
                                />
                              </v-btn>
                            </div>
                          </template>
                          <span v-html="$t('lbl.dataSource.sqlGpUseInDS')"></span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { mapState } from 'vuex';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    SystemProgress,
    IconSvg,
  },
  props: {
    tab: Number,
    isLoading: Boolean,
    items: Array,
    dataPoolList: Array,
    selectedRowGroup: String,
  },
  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  data() {
    return {
      searchGroup: '',
      tableHeight: '525px',
      SummaryList: {
        headers: [
          {
            text: this.$t('tbl.datasource.dbList.db'),
            value: 'sql_grp_nm',
            align: 'center',
          },
          {
            text: this.$t('tbl.datasource.dbList.lastUpdate'),
            value: 'upd_dt',
            align: 'center',
            width: '130px',
          },
          {
            text: this.$t('tbl.datasource.dbList.updateUser'),
            align: 'center',
          },
          {
            text: this.$t('tbl.datasource.dbList.manager'),
            align: 'center',
            sortable: false,
          },
        ],
      },
    };
  },
  methods: {
    openAddSQLGroup(item) {
      EventBus.$emit('open-dialog-add', item);
    },
    openAddD2DSQLGroup(item) {
      EventBus.$emit('open-dialog-d2d', item);
    },
    onClickCodeGroup(item) {
      this.$emit('click-code-group', item);
    },
    onDblClickRowItem() {
      EventBus.$emit('select-sql-group', this.dataPoolList, this.selectedRowGroup);
    },
    deleteItem(item) {
      this.$emit('delete-item', item);
    },
  },
};
</script>

<style></style>
